import z from 'zod'
import { PaginationLinkSchema } from '../payment_tasks/schema'
import { PaymentStatusSchema } from '@/schemas/PaymentStatusSchema'

const ApplicantPaymentSchema = z.object({
  payment_id: z.number(),
  student_name: z.array(z.string()).nullable(),
  applicant_name: z.string(),
  created_datetime: z.string(),
  transaction_type: z.string(),
  provider_name: z.string().nullable(),
  total_amount: z.number(),
  comments: z.string().nullable(),
  invoice_quote: z.string().nullable(),
  status: PaymentStatusSchema,
  status_name: z.string(),
})

const PaginatedApplicantPaymentResponseSchema = z.object({
  current_page: z.number(),
  data: z.array(ApplicantPaymentSchema),
  first_page_url: z.string(),
  from: z.number().nullable(),
  last_page: z.number(),
  last_page_url: z.string(),
  links: z.array(PaginationLinkSchema),
  next_page_url: z.string().nullable(),
  path: z.string(),
  per_page: z.number(),
  prev_page_url: z.string().nullable(),
  to: z.number().nullable(),
  total: z.number(),
})

type ApplicantPayment = z.infer<typeof ApplicantPaymentSchema>
type PaginatedApplicantPaymentResponse = z.infer<
  typeof PaginatedApplicantPaymentResponseSchema
>

export {
  PaginatedApplicantPaymentResponseSchema,
  type PaginatedApplicantPaymentResponse,
  type ApplicantPayment,
}
